/**
 * useAIClassifyLifecycle · AI 智能分类对话窗口的"启动 + 后台轮询"生命周期 hook
 *
 * 跨页面（AIClassifyPage / AIChatDrawer）共享一份生命周期，避免两个页面分别
 * 复制以下逻辑：
 *
 *   1. 启动一次 hydrate · 把 localStorage 的归档任务列表恢复到 store
 *   2. useArchiveTaskPolling · 10s 轮询活跃任务进度
 *
 * 注意：本 hook 不调 useAIClassifySession（那个是会话核心 hook，由父级单独挂载
 * 一份给 ChatActionsProvider 用）。本 hook 只管生命周期副作用。
 *
 * 建夹任务状态轮询不在这里挂 — 每条 BuildTaskStatusMessage 组件实例内通过
 * useBuildTaskDetail(taskId) 自管, 多任务并行先到先显示, 组件卸载自动停止。
 */

import { useEffect } from 'react'
import { useAppDispatch } from '../../../app/hooks'
import { tasksHydrated } from '../../../slices/aiClassify'
import { loadTasksFromStorage } from '../../../slices/aiClassify/taskPersistence'
import { useArchiveTaskPolling } from './useArchiveTaskPolling'

export function useAIClassifyLifecycle(): void {
  const dispatch = useAppDispatch()

  // 启动一次性 hydrate · 把 localStorage 里的任务恢复到 store
  // 抽屉/sidebar 初次 mount 即触发（不等 visible），确保红点 / 未完成轮询能立刻接上
  useEffect(() => {
    const loaded = loadTasksFromStorage()
    if (loaded) {
      dispatch(
        tasksHydrated({
          tasks: loaded.tasks,
          hasUnreadCompletion: loaded.hasUnreadCompletion,
          pendingNotifications: loaded.pendingNotifications
        })
      )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // 后台轮询活跃归档任务进度 · 每 10s 调一次 /web/folder/statistic
  useArchiveTaskPolling()
}
